export default "__VITE_PUBLIC_ASSET__b44f3438__"